import styled from "@emotion/styled";
import Favorite from "@mui/icons-material/Favorite";
import FavoriteBorder from "@mui/icons-material/FavoriteBorder";
import { Checkbox, IconButton, MenuItem, Select, Stack } from "@mui/material";
import { Dispatch, SetStateAction, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import ChefIcon from "../../assets/Browse/ChefIcon";
import GigIcon from "../../assets/Browse/GigIcon";
import DensityIcon from "../../assets/Icons/DensityIcon";
import BrowseType from "../../constants/BrowseType";
import { theme } from "../../mui-customs/Theme";
import { setActiveTab } from "../../redux/createBrowsePageSlice";
import { RootState } from "../../redux/store";
import MenuDrawer from "./MenuDrawer";

interface TopBarProps {
  browseType?: BrowseType;
  setIsDisplayingFavourites: Dispatch<SetStateAction<boolean>>;
}

const StyledMenuItem = styled(MenuItem)`
  min-height: 30px;
`;

const TopBar = ({ browseType, setIsDisplayingFavourites }: TopBarProps) => {
  const [displayMenuDrawer, setDisplayMenuDrawer] = useState(false);
  const dispatch = useDispatch();
  const userUid = useSelector((state: RootState) => state.user.user.uid);
  const activeTab = useSelector(
    (state: RootState) => state.browsePage.activeTab
  );

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      sx={{
        p: 3,
        position: { xs: "fixed", md: "static" },
        top: 0,
        width: "100%",
        background: theme.whiteBg.WBG1,
        zIndex: "99",
      }}
    >
      <Stack spacing={2} direction="row" alignItems="center">
        <Select
          sx={{
            height: "32px",
            width: "60px",
            backgroundColor: theme.whiteBg.WBG3,
            borderRadius: "8px",
            "& .MuiOutlinedInput-notchedOutline": {
              border: "none",
            },
            "& .MuiSelect-select": {
              padding: 1,
              pt: "15px",
            },
          }}
          value={browseType ?? BrowseType.Gig}
          onChange={(e) => {
            if (e.target.value === BrowseType.Chef) {
              dispatch(setActiveTab(BrowseType.Chef));
            } else {
              dispatch(setActiveTab(BrowseType.Gig));
            }
          }}
        >
          <StyledMenuItem value={BrowseType.Chef}>
            <ChefIcon />
          </StyledMenuItem>
          <StyledMenuItem value={BrowseType.Gig}>
            <GigIcon />
          </StyledMenuItem>
        </Select>
      </Stack>
      <Stack spacing={2} direction="row" alignItems="center">
        {userUid && (
          <Checkbox
            sx={{
              backgroundColor: `${theme.whiteBg.WBG4} !important`,
              height: "34px",
              width: "34px",
            }}
            onChange={() => {
              setIsDisplayingFavourites(
                (isDisplayingFavourites) => !isDisplayingFavourites
              );
            }}
            icon={
              <FavoriteBorder
                sx={{ color: theme.grey2[500], fontSize: "22px" }}
              />
            }
            checkedIcon={
              <Favorite sx={{ color: theme.brand2[500], fontSize: "22px" }} />
            }
          />
        )}
        <IconButton
          sx={{
            background: `${theme.whiteBg.WBG3} !important`,
            height: "34px",
            width: "34px",
          }}
          onClick={() => {
            setDisplayMenuDrawer(true);
          }}
        >
          <DensityIcon />
        </IconButton>
        <MenuDrawer
          openState={displayMenuDrawer}
          handleClose={() => {
            setDisplayMenuDrawer(false);
          }}
        />
      </Stack>
    </Stack>
  );
};

export default TopBar;
